module.exports = __webpack_public_path__ + "8172bc46d525495eabaa592668cba7f6.png";